import { Billee } from './billee';
import { PaymentPlan } from './payment-plan';

export class BillingOptions {
  billees: Billee[];
  paymentPlans: PaymentPlan[];
  policyNumber: string;
  primaryInsuredEmailAddress?: string;
}
